module.exports = __webpack_public_path__ + "media/images/top/feature/top-features-3-3e4d22be7c7148593c1a47e76398652c.png";